import { Global03ActionMianbanpinjieLineIcon, ToolTip } from '@kim/ui';
import React, { useMemo } from 'react';
import intl from '@/internationalzation/intl';
import './index.less';

interface IFoldButtonProps {
  onClick: () => void;
  iconSize?: number;
  className?: string;
  tooltip?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const FoldButton = (props: IFoldButtonProps) => {
  const {
    onClick,
    iconSize = 16,
    className = '',
    onMouseEnter,
    onMouseLeave,
    tooltip = true,
  } = props;
  const content = useMemo(() => {
    return (
      <div
        className={`kim-ai-mario-fold-button ${className}`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Global03ActionMianbanpinjieLineIcon
          size={iconSize}
          className="top-btn-icon fold-icon"
        />
      </div>
    );
  }, [onClick, className, iconSize, onMouseEnter, onMouseLeave]);
  return tooltip ? (
    <ToolTip placement="bottom" overlay={intl.t('mario.panel.hovertips')}>
      {content}
    </ToolTip>
  ) : (
    content
  );
};
